"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionStatus = void 0;
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["NOT_CONNECTED"] = 1] = "NOT_CONNECTED";
    ConnectionStatus[ConnectionStatus["CONNECTED"] = 2] = "CONNECTED";
    ConnectionStatus[ConnectionStatus["DISCONNECTED"] = 3] = "DISCONNECTED";
})(ConnectionStatus || (exports.ConnectionStatus = ConnectionStatus = {}));
